import CompraDelete from './CompraDelete'
export {CompraDelete}
export default CompraDelete
